'use es6';

import { authLoaded } from 'crm_data/auth/AuthActions';
export const setupData = auth => {
  require('crm_data/gates/IsUngatedStore');
  authLoaded(auth);
};